import React from 'react';
import { CompleteOnboardingStepDto } from '@api/Api';
import {
  ApprovalRoutingIcon,
  OnboardingAssetIcon,
  PlatformSearchAudioIcon,
  OnboardingCollaborateIcon,
  OnboardingTaskIcon
} from '@icons';

type OnboardingStep = {
  type: CompleteOnboardingStepDto['type'] | 'review-asset';
  title: string;
  description: string;
  button: string;
  icon: React.JSX.Element;
};

export const onboardingSteps: OnboardingStep[] = [
  {
    type: 'create-campaign',
    title: 'Create Your First Project',
    description:
      'Name your project, set access permissions, and start collaborating instantly.',
    button: 'Create project',
    icon: <PlatformSearchAudioIcon className="aw-icon" />
  },
  {
    type: 'upload-asset',
    title: 'Upload Media',
    description:
      'Add videos, images, PDFs, slides, and more — all in one place.',
    button: 'Upload',
    icon: <OnboardingAssetIcon className="aw-icon" />
  },
  {
    type: 'route-for-approval',
    title: 'Route for Approval',
    description:
      'Automate feedback and approvals across teams and stakeholders.',
    button: 'Route',
    icon: <ApprovalRoutingIcon className="aw-icon" />
  },
  {
    type: 'review-asset',
    title: 'Review Media',
    description:
      'Quickly gather feedback on files from teammates, clients, or vendors.',
    button: 'Collaborate',
    icon: <OnboardingCollaborateIcon className="collaborate-icon" />
  },
  {
    type: 'create-task-from-comment',
    title: 'Turn Feedback into Tasks',
    description:
      'Convert comments into to-dos, assign owners, and keep projects moving.',
    button: 'Create task',
    icon: <OnboardingTaskIcon className="task-icon" />
  }
];

export function onboardingPercentage(isContributor: boolean, types: string[]) {
  const steps = onboardingSteps.filter((it) => {
    if (isContributor)
      return it.type !== 'route-for-approval' && it.type !== 'create-campaign';
    return true;
  });

  const userComplete = types.filter(
    (it) => steps.findIndex((x) => x.type === it) > -1
  ).length;

  return { total: steps.length, completed: userComplete, steps };
}
